<template>
  <div style="overflow-y: scroll">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <div class="body-2 mt-3">- TAMBAHAN CITA - CITA</div>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm6 md3>
        <v-text-field v-model="paramData.mnt_cita2_1.answer" label="1. "></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3 class="ml-4">
        <v-text-field v-model="paramData.mnt_cita2_2.answer" label="2. "></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3 class="ml-4">
        <v-text-field v-model="paramData.mnt_cita2_3.answer" label="3. "></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="currentMember.tingkat_pendidikan==='IX'">
      <v-flex xs12 sm12 md12>
        <div class="body-2 mt-3">- PERTIMBANGAN PEMILIHAN KELANJUTAN STUDI YANG DIINGINKAN.</div>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="currentMember.tingkat_pendidikan==='IX'">
      <v-flex xs12 sm12 md12>
        <v-radio-group v-model="paramData.mnt_studi_lanjut_smp.answer" row>
          <v-radio label="SMA" value="SMA"></v-radio>
          <v-radio label="SMK" value="SMK"></v-radio>
          <v-radio label="MA" value="MA"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="currentMember.tingkat_pendidikan==='X' || currentMember.tingkat_pendidikan==='IX'  ">
      <v-flex xs12 sm12 md12>
        <div class="body-2 mt-3">- PERTIMBANGAN PEMILIHAN PERMINTAAN / JURUSAN YANG DIINGINKAN. UNTUK SMP KLS IX & SMA KLS X.</div>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="currentMember.tingkat_pendidikan==='X' || currentMember.tingkat_pendidikan==='IX'">
      <v-flex xs12 sm12 md12>
        <v-radio-group row v-model="paramData.mnt_jurusan_lanjut_sma.answer" >
          <v-radio label="IPA" value="IPA"></v-radio>
          <v-radio label="IPS" value="IPS"></v-radio>
          <v-radio label="BHS" value="BHS"></v-radio>
          <v-radio label="AGAMA" value="AGAMA"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="currentMember.tingkat_pendidikan==='X' || currentMember.tingkat_pendidikan==='IX' ">
      <v-flex xs12 sm12 md12>
        <div class="body-2 mt-3">- PERTIMBANGAN PEMILIHAN JURUSAN YANG DIINGINKAN MINIMAL "SATU". UNTUK SMP KLS IX & SMA KLS X.</div>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="currentMember.tingkat_pendidikan==='X' || currentMember.tingkat_pendidikan==='IX'">
      <v-flex xs12 sm6 md3>
        <v-text-field v-model="paramData.mnt_jurusan_lanjut_smk_1.answer" label="1. "></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3 class="ml-4">
        <v-text-field v-model="paramData.mnt_jurusan_lanjut_smk_2.answer" label="2. "></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3 class="ml-4">
        <v-text-field v-model="paramData.mnt_jurusan_lanjut_smk_3.answer" label="3. "></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="
      currentMember.tingkat_pendidikan==='XI' 
      || currentMember.tingkat_pendidikan==='XII'
      || currentMember.tingkat_pendidikan==='DIPLOMA'
      || currentMember.tingkat_pendidikan==='S1'
      || currentMember.tingkat_pendidikan==='S2'
      || currentMember.tingkat_pendidikan==='S3'
      || currentMember.tingkat_pendidikan==='DEWASA_UMUM'
      ">
      <v-flex xs12 sm12 md12>
        <div class="body-2 mt-3">- PERTIMBANGAN KELANJUTAN STUDI YANG DIINGINKAN MINIMAL "SATU"</div>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="
      currentMember.tingkat_pendidikan==='XI' 
      || currentMember.tingkat_pendidikan==='XII'
      || currentMember.tingkat_pendidikan==='DIPLOMA'
      || currentMember.tingkat_pendidikan==='S1'
      || currentMember.tingkat_pendidikan==='S2'
      || currentMember.tingkat_pendidikan==='S3'
      || currentMember.tingkat_pendidikan==='DEWASA_UMUM'
      ">
      <v-flex xs12 sm6 md3>
        <v-text-field v-model="paramData.mnt_studi_lanjut_sma_smk_1_fakultas.answer" label="1. Fakultas "></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3 class="ml-4">
        <v-text-field v-model="paramData.mnt_studi_lanjut_sma_smk_1_prodi.answer" label="Prodi "></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="currentMember.tingkat_pendidikan==='XI' || currentMember.tingkat_pendidikan==='XII'">
      <v-flex xs12 sm6 md3>
        <v-text-field v-model="paramData.mnt_studi_lanjut_sma_smk_2_fakultas.answer" label="2. Fakultas "></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3 class="ml-4">
        <v-text-field v-model="paramData.mnt_studi_lanjut_sma_smk_2_prodi.answer" label="Prodi "></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="
      currentMember.tingkat_pendidikan==='XI' 
      || currentMember.tingkat_pendidikan==='XII'
      || currentMember.tingkat_pendidikan==='DIPLOMA'
      || currentMember.tingkat_pendidikan==='S1'
      || currentMember.tingkat_pendidikan==='S2'
      || currentMember.tingkat_pendidikan==='S3'
      || currentMember.tingkat_pendidikan==='DEWASA_UMUM'
      ">
      <v-flex xs12 sm12 md12>
        <div
          class="body-2 mt-3"
        >- PERTIMBANGAN KELANJUTAN STUDI KEDINASAN YANG DIINGINKAN MINIMAL "SATU"</div>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="
      currentMember.tingkat_pendidikan==='XI' 
      || currentMember.tingkat_pendidikan==='XII'
      || currentMember.tingkat_pendidikan==='DIPLOMA'
      || currentMember.tingkat_pendidikan==='S1'
      || currentMember.tingkat_pendidikan==='S2'
      || currentMember.tingkat_pendidikan==='S3'
      || currentMember.tingkat_pendidikan==='DEWASA_UMUM'
      ">
      <v-flex xs12 sm6 md3>
        <v-text-field v-model="paramData.mnt_studi_lanjut_sma_smk_kedinasan.answer" label="1. "></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "psiko-exercise-main-cit2-jurusan",
  props: {
    paramData: Object
  },
  data: () => ({}),
  computed: {
  ...mapState({
      currentMember: state => state.auth.currentMember,
    }),
  },
  methods: {}
};
</script>